export default __webpack_public_path__ + "static/media/Prancheta OM.fa2f5661.svg";